//this page is for showing all the Reviews from the customers
import React, { useState, useEffect } from "react";
import SideMenu from "../../../components/organisms/sidebar";
import LoggedHeader from "../../Common/loggedHeader";
import { Table, Select, MenuItem, Button, Menu, Typography, Box, Stack, TextField, Paper } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useMutation, useQuery } from "@apollo/client";
import { LIST_REVIEW_ADMIN } from "../../../Graphql/queries";
import { APPROVE_REVIEW } from "../../../Graphql/mutations";
import { REFRESH_GOOGLE_REVIEWS } from "../../../Graphql/mutations";
import { UPDATE_CATERER } from "../../../Graphql/mutations";
import { GET_ONE_CATERER } from "../../../Graphql/queries";
import Pagination from "@mui/material/Pagination";
import { toggleSnackbar,authVar } from "../../../ReactiveVariables/index";
import DialogBox from "../../Common/dialogBox";
import Switch from '@mui/material/Switch';
import moment from "moment";
import { styled } from '@mui/material/styles';
import {useNavigate } from "react-router-dom";

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ?  '#DC3545': 'green',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : '#DC3545',
      boxSizing: 'border-box',
    },
  }));

export default function Reviews({ catererId }) {
  const navigate = useNavigate()
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkedValue,setCheckedValue] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null);
  const [page, setPage] = useState(1);
  // Admin override rating
  const [overrideRating, setOverrideRating] = useState("");
  // Google Places ID input
  const [googlePlacesId, setGooglePlacesId] = useState("");
  // Load existing admin_rating
  const { data: catererData } = useQuery(GET_ONE_CATERER , {
    variables: { getOneCatererId: catererId, agsType: "id" },
    skip: !catererId
  });
  useEffect(() => {
    const rating = catererData?.getOneCaterer?.admin_rating;
    if (rating != null) setOverrideRating(rating.toString());
    
    // Load existing Google Places ID
    const placesId = catererData?.getOneCaterer?.google_places_id;
    if (placesId) setGooglePlacesId(placesId);
  }, [catererData]);
  // Mutation to save override
  const [updateCaterer, { loading: savingRating }] = useMutation(
    UPDATE_CATERER,
    { 
      refetchQueries: ["GetOneCaterer", "ListReviews"],
      onCompleted: (data) => {
        toggleSnackbar({
          status: true,
          message: "Caterer updated successfully",
          variant: "success"
        });
      },
      onError: (err) => {
        toggleSnackbar({
          status: true,
          message: err.message,
          variant: "error"
        });
      }
    }
  );
  const reviewVariable = {
    skip: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
    adminFlag: true,
    catererId: catererId,
    search: search
  }
  const {data,loading}= useQuery(LIST_REVIEW_ADMIN,{variables:reviewVariable})
  const [approveReview] = useMutation(APPROVE_REVIEW,{refetchQueries: ["ListReviews"],
  onCompleted:(res)=>{
    setSelectedItem(null)
  }})

  const [refreshGoogleReviews, { loading: refreshLoading }] = useMutation(
    REFRESH_GOOGLE_REVIEWS,
    {
      variables: { catererId },
      onCompleted: () => {
        toggleSnackbar({
          status: true,
          message: "Google reviews refreshed",
          variant: "success"
        });
      },
      onError: (err) => {
        toggleSnackbar({
          status: true,
          message: err.message,
          variant: "error"
        });
      },
      refetchQueries: ["GetOneCaterer", "ListReviews"]
    }
  );
  const handleChangePage = (e, pages) => {
    setPage(pages);
  };
  //pagination
  function handlePageInputChange(event) {
    setRowsPerPage(Number(event.target.value));
    setPage(1);
  }
  //for activating the switch to approve and disapprove reviews
  function toggleSwitch(){
    let requestData={
        reviewId: selectedItem?._id,
        approvalStatus: checkedValue, 
        customerId: selectedItem?.customerId,
        catererId: selectedItem?.catererId
    }
    try { approveReview({ variables: requestData })
        .then((res) => {
          toggleSnackbar({
            status: true,
            message: checkedValue?"Review activated successfully":"Review deactivated successfully",
            variant: 'success'
          });
        })
        .catch((err) => {
          const message = err && err.message
          if(message==="Not authenticated"){
            localStorage.clear();
            authVar({
              loaded: true,
              auth: false,
            });
            navigate("/admin", { state: "noAuth" })
          }else{
          toggleSnackbar({
            status: true,
            message: message,
            variant: "error",
          });
        }
        });
      } catch (err) {
        const message = err && err.message;
        toggleSnackbar({
          status: true,
          message: message,
          variant: "error",
        });
      }
  }
  return (
    <div>
      <LoggedHeader title="Review" user="admin" />
      <SideMenu selected="Reviews" user="admin" />

      {openDialog && (<DialogBox
        setOpenDialog={setOpenDialog}
        handleDelete={toggleSwitch}
        openDialog={openDialog}
        title="Update Review"
        discription={checkedValue?"Are you sure you want to activate this review?":"Are you sure you want to deactivate this review?"}
      />
      )}
      <div>
        <div className="contentWrapInner promocode-table">
          {/* Google Reviews Controls at the top */}
          {catererId && (
            <Box component={Paper} elevation={2} sx={{ p: 3, mb: 3, maxWidth: 600, width: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Google Reviews Integration
              </Typography>
              <Stack spacing={2}>
                {/* Google Places ID row */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <TextField
                    label="Google Places ID"
                    value={googlePlacesId}
                    onChange={e => setGooglePlacesId(e.target.value)}
                    placeholder="e.g., ChIJ..."
                    size="small"
                    fullWidth
                  />
                  <Button
                    variant="contained"
                    disabled={savingRating}
                    onClick={() => {
                      updateCaterer({
                        variables: {
                          id: catererId,
                          data: { google_places_id: googlePlacesId || null }
                        }
                      });
                    }}
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    {savingRating ? "Saving..." : "Save Places ID"}
                  </Button>
                </Box>
                {/* Help text below Places ID row */}
                {!catererData?.getOneCaterer?.google_places_id && (
                  <Typography variant="body2" color="text.secondary">
                    💡 <b>Need help?</b> Try the Fetch button, or copy the ID from Google Maps URL.<br />
                    Name variations are handled automatically.
                  </Typography>
                )}
                {/* Admin Rating row */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <TextField
                    label="Admin Rating (0–5)"
                    type="number"
                    value={overrideRating}
                    onChange={e => setOverrideRating(e.target.value)}
                    inputProps={{ min: 0, max: 5, step: 0.1 }}
                    size="small"
                    sx={{ width: 200 }}
                  />
                  <Button
                    variant="contained"
                    disabled={savingRating}
                    onClick={() => {
                      const val = parseFloat(overrideRating);
                      updateCaterer({
                        variables: {
                          id: catererId,
                          data: { admin_rating: isNaN(val) ? null : val }
                        }
                      });
                    }}
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    {savingRating ? "Saving..." : "Save Rating"}
                  </Button>
                </Box>
                <Button
                  variant="contained"
                  disabled={refreshLoading}
                  onClick={() => refreshGoogleReviews()}
                  
                >
                  {refreshLoading ? "Refreshing..." : "Fetch Google Reviews"}
                </Button>
              </Stack>
            </Box>
          )}
          {/* Review summary and table below */}
          <div className="location-head">
            <div className="location-head-title" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 16 }}>
              {data?.listReviews?.count !== undefined ? (
                <h5>{`${data.listReviews.count} Reviews`}</h5>
              ) : (
                <p>Loading...</p>
              )}
              {catererId && catererData?.getOneCaterer?.averageRating != null && (
                <Typography variant="subtitle1" sx={{ ml: 2 }}>
                  Avg: {Number(catererData.getOneCaterer.averageRating).toFixed(1)}
                </Typography>
              )}
              {catererId && (
                <Typography variant="subtitle2" sx={{ ml: 2, color: 'text.secondary' }}>
                  Places ID: {catererData?.getOneCaterer?.google_places_id ? 'Set' : 'Not set'}
                </Typography>
              )}
            </div>
          </div>
          <TableContainer>
            <Table
              className="commonTabel"
              sx={{ minWidth: 650 }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Date & Time</TableCell>
                  <TableCell align="center">Rating</TableCell>
                  <TableCell width="30%">Review</TableCell>
                  <TableCell >Customer</TableCell>
                  <TableCell >Caterer</TableCell>
                  <TableCell align="center">Source</TableCell>
                  <TableCell align="center">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p> Loading...</p>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : data && data?.listReviews?.reviewsList?.length > 0 ? (
                  data &&
                  data?.listReviews?.reviewsList?.map((item) => (
                    <TableRow >
                      <TableCell component="th" scope="row">
                        {moment(item?.reviewDate).format('llll')}
                      </TableCell>
                      <TableCell align="center" component="th" scope="row">
                        {Array.from({ length: 5 }, (_, i) => (
                          <span key={i}>{i < (item?.star || 0) ? '★' : '☆'}</span>
                        ))}
                      </TableCell>
                      <TableCell component="th" scope="row">
                      {item?.comment}
                      </TableCell>
                      <TableCell style={{cursor:"pointer"}} onClick={()=>{navigate(`/customers/${item?.customerId}`)}} component="th" scope="row">
                        {item?.customerName}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`/admin/caterers/${item?.catererId}`)}
                        component="th"
                        scope="row"
                      >
                        {item?.catererName}
                      </TableCell>
                      <TableCell align="center">{item.source_type}</TableCell>
                      <TableCell align="center">
                        <Button>
                            <AntSwitch onChange={(e)=>{setOpenDialog(true);setCheckedValue(e.target.checked);setSelectedItem(item)}} 
                            size={'70'} checked={item?.approvalStatus} inputProps={{ 'aria-label': 'ant design' }} />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : search ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p>No data Found</p>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p>No list added Yet!</p>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="table-pagenation">
          <div className="rowCount">
            <Select
              // variant="outlined"
              onChange={handlePageInputChange}
              value={rowsPerPage}
            >
              <MenuItem value={10}>{10}</MenuItem>
              <MenuItem value={25}>{25}</MenuItem>
              <MenuItem value={50}>{50}</MenuItem>
              <MenuItem value={100}>{100}</MenuItem>
            </Select>
          </div>

          <Stack spacing={2}>
            <Pagination
              className="tableCount"
              count={Math.ceil(data?.listReviews?.count / rowsPerPage)}
              variant="outlined"
              shape="rounded"
              page={page}
              onChange={handleChangePage}
            />
          </Stack>
        </div>
      </div>
    </div>
  )
}